import styled, { css } from 'styled-components'

import { brkmax, themeColor } from '../../components/theme'
import { CollapseContent } from '../../components/Collapse'
import { Flex } from '../../components/Flex'
import { Image } from '../../components/Image'
import { Title } from '../../components/Text'

export const DocumentIcon = ({ size }: { size: 'small' | 'large' }) => (
  <Image alt="document" type="fileText" width={size === 'small' ? '20px' : '24px'} />
)

export const StyledCollapseContent = styled(CollapseContent)`
  width: 100%;
  margin-left: 5px;
  margin-right: 5px;
`

export const DetailsHeaderWrapper = styled(Flex)`
  width: 100%;
  height: 45px;
  align-items: center;
  background-color: ${themeColor('bgPrimary')};
  border-radius: 4px;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 15px;
`

export const SectionTitle = styled(Title)`
  ${brkmax(
    0,
    css`
      font-size: 16px;
    `
  )}
  font-weight: bold;
  background-color: ${themeColor('bgPrimary')};
  border-radius: 4px;
  width: 100%;
`

export const ProductTitle = styled(Title)`
  display: inline-flex;
`
